export default {
  configureProps: () => {},
  connectNodes: () => {},
  getValue: () => 0,
  disconnectNodes: () => {},
  createNode: () => {},
};
